var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container page-container d-flex flex-column shadow p-0"},[_vm._t("default",[_c('router-view',{on:{"logout":function($event){return _vm.$emit('logout')}}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }